import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import React from 'react';
import { IDailyQuestionResponse } from 'src/api/models/Daily';

import { QuestionBox } from './QuestionBox';
interface SummaryProps {
  jobId: number;
  initialQuestions: any;
  onChange: (q: any) => void;
  disabled?: boolean;
}

export const Summary: React.FC<SummaryProps> = ({
  initialQuestions,
  onChange,
  disabled = false,
}) => {
  const [answers, setAnswers] =
    React.useState<IDailyQuestionResponse[]>(initialQuestions);

  React.useEffect(() => {
    onChange(answers);
  }, [answers]);

  const updateNote = (id: number, note: string) => {
    setAnswers((prevState) => {
      return prevState.map((v) => {
        if (v.id === id)
          return {
            ...v,
            note,
          };
        return v;
      });
    });
  };

  const updateValue = (id: number, value: string) => {
    setAnswers((prevState) => {
      return prevState.map((v) => {
        if (v.id === id)
          return {
            ...v,
            value,
          };
        return v;
      });
    });
  };

  const renderQuestions = () => {
    if (answers.length === 0) {
      return <Text>No questions to display</Text>;
    }
    return answers.map((q) => {
      return (
        <QuestionBox
          key={q.id}
          disabled={disabled}
          question={q}
          onValueChange={updateValue}
          onNoteChange={updateNote}
        />
      );
    });
  };

  return <Stack gap="md">{renderQuestions()}</Stack>;
};
